import styled from 'styled-components';
import { th } from 'style/theme';
import { sizes } from 'style';

export const GroupMemberWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${th('colors.confetti+4')};
  border-radius: 8px;
  overflow: hidden;

  @media ${sizes.desktop} {
    border-radius: 16px;
  }
`;
